import { render, staticRenderFns } from "./WarehouseTabEntry.vue?vue&type=template&id=961a850c"
import script from "./WarehouseTabEntry.vue?vue&type=script&lang=js"
export * from "./WarehouseTabEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports